// extracted by mini-css-extract-plugin
module.exports = {"rtoDocList":"_3C-rk","documentListWrapper":"_3DT7l","viewAll":"xlbfQ","rtoHeader":"_2sXKW","rtoDocumentCard":"_1B3dR","rtoIconCard":"_3_CY8","verified":"_1I1vl","failed":"_1tNvg"};